import { styled } from 'styled-components';
import { Media } from '@/js/libs/ui/src/theme/Media';
export const TableCardTitleWrapper = styled.div `
  ${({ theme }) => theme.typography.title}

  & span {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  @media ${Media.xsMax} {
    width: 100%;

    span {
      justify-content: space-between;
    }
  }
`;
